import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/leave/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/leave/requests" });
  },
});
